// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vue2Filters from 'vue2-filters'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueLightbox from 'vue-lightbox'

Vue.use(Vue2Filters)
Vue.use(VueAxios, axios)

require('bootstrap')
Vue.component('Lightbox', VueLightbox)
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js